/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_QuartzInputs */

const en_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartz`)
};

const es_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuarzo`)
};

const fr_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartz`)
};

const de_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarz`)
};

const ja_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クォーツ`)
};

const zh_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`石英`)
};

const ar_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كوارتز`)
};

const id_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuarsa`)
};

const it_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarzo`)
};

const ru_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кварцевые`)
};

const pt_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartzo`)
};

const ko_val_quartz = /** @type {(inputs: Val_QuartzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쿼츠`)
};

/**
* | output |
* | --- |
* | "Quartz" |
*
* @param {Val_QuartzInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_quartz = /** @type {((inputs?: Val_QuartzInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_QuartzInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_quartz(inputs)
	if (locale === "es") return es_val_quartz(inputs)
	if (locale === "fr") return fr_val_quartz(inputs)
	if (locale === "de") return de_val_quartz(inputs)
	if (locale === "ja") return ja_val_quartz(inputs)
	if (locale === "zh") return zh_val_quartz(inputs)
	if (locale === "ar") return ar_val_quartz(inputs)
	if (locale === "id") return id_val_quartz(inputs)
	if (locale === "it") return it_val_quartz(inputs)
	if (locale === "ru") return ru_val_quartz(inputs)
	if (locale === "pt") return pt_val_quartz(inputs)
	return ko_val_quartz(inputs)
});